import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

const AuthenticationLayout = React.memo(() => {
  const { t } = useTranslation('authentication');
  return (
    <div className={'authentication-layout'}>
      <div className="authentication-layout__welcome">
        <div className={'authentication-layout__bg-pattern'} />
        <div className={'authentication-layout__welcome__content'}>
          <div className={'authentication-layout__brand'}>
            <img src="/restavo.svg" alt="Restavo logo" />
            <span>Restavo</span>
          </div>
          <h2>{t('hero.title')}</h2>
          <h4>{t('hero.description')}</h4>
        </div>
        <div className="authentication-layout__welcome__copyright">
          <h4>©2026 Restavo Inc</h4>
          <div className={'authentication-layout__welcome__terms'}>
            <span>{t('common.terms')}</span>
            <span>{t('common.privacy')}</span>
          </div>
        </div>
      </div>
      <div className="authentication-layout__main-content">
        <Outlet />
      </div>
    </div>
  );
});

export default AuthenticationLayout;
